<template>
  <CHeader fixed withSubHeader light>
    <CToggler
    in-header
    class="ml-3 d-lg-none"
    @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/dashboard">
      <img src="../assets/images/indocyber-logo.png" class="logo-fif" alt="">
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <!--<CHeaderNavLink :to="{ name: 'Dashboard'}">
          Menu Utama
        </CHeaderNavLink>-->
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-2">
      <CHeaderNavItem class="d-md-down-none mr-3">
        <!--Selamat Datang, <span class="font-weight-bold">{{$store.state.roleName}}</span>-->
        <span>Selamat Datang, <span style="font-weight:bold;">{{ userName }}</span></span>
      </CHeaderNavItem>
      <!-- Notification starts -->
      <CHeaderNavItem class="mr-2 border-left h-100"></CHeaderNavItem>
      <CHeaderNavItem class="mr-3">
        <CDropdown
          inNav
          class="c-header-nav-items"
          placement="bottom-end"
          add-menu-classes="py-0"
        >
          <template #toggler>
            <CHeaderNavLink class="pr-0">
              <a @click="onClickNotification"><CIcon name="cil-bell" class="mr-0" /></a>
            </CHeaderNavLink>
          </template>
          <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>Notification</strong>
          </CDropdownHeader>
          <CRow class="text-center px-2 py-3" v-if="!notification.isLoaded">
            <CCol>
              <b-spinner small variant="secondary" type="grow" class="mr-2" label="Loading Notification..."></b-spinner> 
              <span class="notification-message text-muted">loading notification...</span>
            </CCol>
          </CRow>
          <template v-else>
            <CRow class="text-center px-2 py-3" v-if="notification.items.length == 0">
              <CCol>
                <span class="notification-message text-muted">Tidak ada notifikasi</span>
              </CCol>
            </CRow>
            <template v-else>
              <CRow class="px-2 mt-1" v-for="(item, index) in notification.items" :key="item.id" :class="{'mt-3': index == 0}">
                <CCol>
                  <div class="notification-message text-muted">{{ item.message }}</div>
                  <div class="notification-time text-muted font-weight-bold" :class="{'mb-3': index == (notification.items.length-1)}">{{ generateTime(item.createdAt) }}</div>
                  <hr v-if="index != (notification.items.length-1)" />
                </CCol>
              </CRow>
              <template v-if="notification.currentPage < notification.totalPages">
                <hr class="p-0 m-0" />
                <a @click="appendNotification">
                  <CRow class="px-2 py-3 text-center notification-cursor-clickable">
                    <CCol>
                      <span class="text-muted small font-weight-bold" v-if="!notification.isAppending">Load more</span>
                      <template v-else>
                        <b-spinner small variant="secondary" class="mr-2" label="Loading more..."></b-spinner>
                        <span class="text-muted small font-weight-bold">Loading...</span>
                      </template>
                    </CCol>
                  </CRow>
                </a>
              </template>
            </template>
          </template>
        </CDropdown>
      </CHeaderNavItem>
      <!-- Notification ends -->
      <CHeaderNavItem class="mr-2 border-left h-75" v-if="!isInternalUser"></CHeaderNavItem>
      <CHeaderNavItem v-if="!isInternalUser">
        <CButton
          size="sm"
          class="mr-2 btn-icon p-0 custom-button-white"
          title="Change Password"
          @click="showEditPasswordModal = true"
        >
          <CIcon name="cil-braille" class="mt-0 mb-1"/>
        </CButton>
      </CHeaderNavItem>
      <CHeaderNavItem class="mr-2 border-left h-75"></CHeaderNavItem>
      <CHeaderNavItem>
        <CButton
          size="sm"
          class="btn-icon p-0 custom-button-white"
          title="Logout"
          @click="showLogoutModal = true"
        >
          <CIcon name="cil-account-logout" class="mt-0 mb-1"/>
        </CButton>
      </CHeaderNavItem>
    </CHeaderNav>
    <b-modal
      v-model="showLogoutModal"
      no-close-on-backdrop
      no-close-on-esc
      centered
      title="Logout"
      hide-header-close
      hide-footer
      scrollable
      size="sm"
    >
      <CRow>
        <CCol class="col-12">
          <p>Anda yakin ingin logout ?</p>
        </CCol>
      </CRow>
      <CRow class="mt-2 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="showLogoutModal = false">Cancel</b-btn>
          <b-btn variant="primary" type="submit" style="width:6rem" @click="doLogout()">
            Logout
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
    <CForm>
      <b-modal
        v-model="showEditPasswordModal"
        title="Change Password"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        centered size="sm">
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.currentPassword.feedback"
                label="Current Password"
                label-for="user-currentPassword"
                :state="editPasswordUser.currentPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.currentPassword.value"
                  :state="editPasswordUser.currentPassword.isValid"
                  placeholder="Current Password"
                  maxlength="50"
                  id="user-currentPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.newPassword.feedback"
                label="New Password"
                label-for="user-newPassword"
                :state="editPasswordUser.newPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.newPassword.value"
                  :state="editPasswordUser.newPassword.isValid"
                  placeholder="New Password"
                  maxlength="50"
                  id="user-newPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                :invalid-feedback="editPasswordUser.confirmNewPassword.feedback"
                label="Confirm New Password"
                label-for="user-confirmNewPassword"
                :state="editPasswordUser.confirmNewPassword.isValid"
              >
                <b-form-input
                  type="password"
                  v-model="editPasswordUser.confirmNewPassword.value"
                  :state="editPasswordUser.confirmNewPassword.isValid"
                  placeholder="Confirm New Password"
                  maxlength="50"
                  id="user-confirmNewPassword"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <template #modal-footer>
          <CButton color="primary" variant="outline" @click="showEditPasswordModal = false">Back</CButton>
          <CButton class="ml-2" color="primary" type="submit" @click="editUserPassword" :disabled="isLoading.editPassword">
            <b-spinner small type="grow" v-if="isLoading.editPassword" /> 
            {{ isLoading.editPassword ? 'Loading...' : 'Change Password' }}
          </CButton>
        </template>
      </b-modal>
    </CForm>
  </CHeader>
</template>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
  .btn-icon {
    width: 2rem;
    min-width: 2rem;
  }
</style>


<script>
    import moment from 'moment';
    export default {
      name: "TheHeader",
      components: {
      },
      props: {
        isLoggedIn: {
          type: Boolean,
          default: false
        }
      },
      data(){
        return {
          userName: "",
          showLogoutModal: false,
          showEditPasswordModal: false,
          isLoading: {
            editPassword: false
          },
          editPasswordUser: {
            currentPassword: {
              value: '',
              feedback: 'This input is required.',
              isValid: null,
              isRequired: true,
              payloadKey: "currentPassword"
            },
            newPassword: {
              value: '',
              feedback: 'This input is required.',
              isValid: null,
              isRequired: true,
              payloadKey: "newPassword"
            },
            confirmNewPassword: {
              value: '',
              feedback: 'Please repeat the same password.',
              isValid: null,
              isRequired: true
            },
          },

          notification: {
            isLoaded: true,
            isAppending: false,
            items: [],
            perPage: 10,
            currentPage: 1,
            totalRows: 0,
            totalPages: 0,
          }
        }
      },
      methods: {

        generateTime(createdAt) {
          return moment(createdAt, 'DD-MM-YYYY HH:mm').fromNow()
        },

        onClickNotification() {
          // if(!this.$el.querySelector('.dropdown-notif-menu').classList.contains('show') && this.notification.isLoaded) {
          if(!this.$el.querySelector('.dropdown-menu').classList.contains('show') && this.notification.isLoaded) {
            this.notification.isLoaded = false
            this.notification.currentPage = 0
            let getUrl = '/user/notification'
            let params = {
              page: 0,
              size: this.notification.perPage
            }
            return this.$axios.get(getUrl, {params: params}).then(response => {
              console.log(response)
              if(response.status == 200){

                this.notification.items = response.data.data.data
                this.notification.totalRows = response.data.data.totalElements
                this.notification.totalPages = response.data.data.totalPages
              }
              else{
                // this.errorAction(response)
                this.$helper.toastError(this, "Load Notifikasi Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
              }
            })
            .catch(error => {
              // this.errorAction(error)
              if(!this.$helper.isEmpty(error.response)){
                this.$helper.toastError(this, "Load Notifikasi Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
              }
              else{
                this.$helper.toastError(this, "Load Notifikasi Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
              }
            })
            .finally(() => {
              this.notification.isLoaded = true
            })
          }
        },

        appendNotification() {
          this.notification.isAppending = true
          let getUrl = '/user/notification'
          let params = {
            page: this.notification.currentPage+1,
            size: this.notification.perPage
          }
          return this.$axios.get(getUrl, {params: params}).then(response => {
            if(response.status == 200){

              this.notification.items = [ ...this.notification.items, ...response.data.data.data ]
              this.notification.currentPage++
            }
            else{
              // this.errorAction(response)
              this.$helper.toastErrwor(this, "Load Notifikasi Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            // this.errorAction(error)
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Load Notifikasi Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Load Notifikasi Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.notification.isAppending = false
          })
        },

        doLogout() {
          localStorage.setItem('fimsAction', 'logout')
          this.$emit("logout")
        },

        editUserPassword(event) {
          event.preventDefault()

          this.isLoading.editPassword = true
          let isFormValid = true
          for(const [key, data] of Object.entries(this.editPasswordUser)){
            // Password Minimal 8 karakter, mengandung angka (0 - 9), huruf besar, huruf kecil, dan karakter khusus (+_)(*&^%$#@!~`[]\;‘,./<>?:“{}|)
            if (key == 'newPassword') {
              if (data.isRequired && this.$helper.isEmpty(data.value)) {
                data.feedback = "This input is required."
                isFormValid = false
                data.isValid = false
              } else if (data.value.length < 8) {
                data.feedback = "Password should contain a minimal 8 characters."
                isFormValid = false
                data.isValid = false
              } else if (!this.$helper.containsSmallLetter(data.value) || !this.$helper.containsCapitalLetter(data.value)) {
                data.feedback = "Password should contain small [a-z] and capital [A-Z] letter."
                isFormValid = false
                data.isValid = false
              } else if (!this.$helper.containsNumber(data.value)) {
                data.feedback = "Password should contain number [0-9]."
                isFormValid = false
                data.isValid = false
              } else if (!this.$helper.containsSpecialCharacter(data.value)) {
                data.feedback = "Password should contain special character [ `!@#$%^&*()_+-=[]{};':\"|,.<>/?~ ]."
                isFormValid = false
                data.isValid = false
              } else{
                data.isValid = null
              }
            } else if (key == 'confirmNewPassword') {
              // Repeat Password on confirm password field
              if (data.isRequired && this.$helper.isEmpty(data.value)) {
                data.feedback = "This input is required."
                isFormValid = false
                data.isValid = false
              } else if (data.value != this.editPasswordUser.newPassword.value) {
                data.feedback = "Please repeat the same password."
                isFormValid = false
                data.isValid = false
              } else{
                data.isValid = null
              }
            } else{
              // The rest of the field
              if (data.isRequired && this.$helper.isEmpty(data.value)) {
                isFormValid = false
                data.isValid = false
              } else{
                data.isValid = null
              }
            }
          }

          if (isFormValid) {
            let postUrl = '/user/changePassword/'
            // only send axios request if role is valid
            if(!this.isInternalUser && (this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Notaris']))){
              this.isSubmitting = true
              let data = new FormData()
              data.set('userId', this.$store.state.userId)
              data.set('currentPassword', this.editPasswordUser.currentPassword.value)
              data.set('newPassword', this.editPasswordUser.newPassword.value)
              this.$axios.post(postUrl, data).then(response => {
                if(response.status == 200){
                  this.$helper.toastSuccess(this.$root, "Change Password Berhasil! " + (response.data.reason ? response.data.reason : ""))
                  this.doLogout()
                  this.showEditPasswordModal = false
                } else{
                  this.$helper.toastError(this, "Change Password Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
                }
              })
              .catch(error => {
                if(!this.$helper.isEmpty(error.response)){
                  this.$helper.toastError(this, "Change Password Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
                }
                else{
                  this.$helper.toastError(this, "Change Password Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
                }
              })
              .finally(() => {
                this.isLoading.editPassword = false
              })
            }
            else{
              this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
              this.isLoading.editPassword = false
            }
          } else{
            this.isLoading.editPassword = false
          }
        },
      },
      created(){
        // this.userName = localStorage.getItem(this.$userNameKeyword)
        this.userName = this.$store.state.userName

        moment.updateLocale("id", { week: {
          dow: 1, // First day of week is Monday
          doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
        }})
      },
      computed:{
        isInternalUser(){
          // return localStorage.getItem(this.$sourceKeyword) == 'HCMS'
          return this.$store.state.source == 'HCMS'
        }
      }
    }
</script>

<style>
.py-0.dropdown-menu {
  width: 384px;
  inset: 10px auto auto 19px !important;
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.dropdown-notif-menu .dropdown-item {
  cursor: default;
}

.notification-message {
  font-size: 0.8rem;
}

.notification-time {
  font-size: 0.7rem;
}
</style>